import script from "./exportModalV2.vue?vue&type=script&setup=true&lang=js"
export * from "./exportModalV2.vue?vue&type=script&setup=true&lang=js"

import "./exportModalV2.vue?vue&type=style&index=0&id=67023652&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67023652"]])

export default __exports__